import React, { useState, useEffect } from "react";
import { Label, eyeIcon, Icon, SSNProps, format, isMaskedSSN } from "./SSN";
import { formatPastedSSN, handleSSNKeyDown } from "./ssnInputBehavior";
import InPlaceError from "components/in-place-error/InPlaceError";
import "./ssn.scss";
import { globalLinkNoTxClass } from "utilities/globalLinkNoTx";

const SsnForMobile = ({
  label,
  errorMessage,
  placeholder,
  isReadOnly,
  isDisabled,
  initialValue,
  onChange,
  onBlur,
}: SSNProps) => {
  const [ssn, setSsn] = useState("");
  const [isSSNVisible, setIsSSNVisible] = useState(false);

  useEffect(() => {
    if (initialValue) {
      setSsn(
        isMaskedSSN(initialValue) ? initialValue : format(initialValue, false)
      );
    }
  }, [initialValue]);

  const updateSSN = (nextValue: string) => {
    const formatted = isMaskedSSN(nextValue) ? nextValue : format(nextValue, false);
    setSsn(formatted);
    onChange?.(formatted);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!isSSNVisible) {
      return;
    }
    updateSSN(e.target.value);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    handleSSNKeyDown(e, ssn, updateSSN, isSSNVisible);
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    updateSSN(formatPastedSSN(ssn, e.clipboardData.getData("text")));
  };

  return (
    <div className="ssn-container">
      {label && <Label label={label} />}
      <div className="ssn__wrapper">
        <input
          className={globalLinkNoTxClass(errorMessage ? "ssn ssn--error" : "ssn")}
          type={isSSNVisible ? "text" : "password"}
          id="ssn"
          name="ssn"
          placeholder={placeholder}
          value={ssn}
          onInput={handleInputChange}
          onKeyDown={handleKeyDown}
          onPaste={handlePaste}
          inputMode="numeric"
          disabled={isDisabled}
          readOnly={isReadOnly}
          onBlur={onBlur}
          spellCheck={false}
          autoComplete="off"
          aria-label={label}
          data-testid="pii-ssn-input"
        />
        <Icon
          icon={eyeIcon(isSSNVisible)}
          isIconPointer
          onIconClick={() => setIsSSNVisible(!isSSNVisible)}
        />
        {errorMessage && <InPlaceError errorPhrase={errorMessage} />}
      </div>
    </div>
  );
};

export default SsnForMobile;
